import i18next from 'i18next';
import toast, { ToastOptions } from 'react-hot-toast';
import { PiWarningCircleFill } from 'react-icons/pi';

export const warningToast = (message: string, options?: ToastOptions) =>
  toast.success(i18next.t(message), {
    icon: <PiWarningCircleFill color='orange' size={40} />,
    duration: Infinity,
    ...options,
  });
